import React, { type FC } from 'react';
import classes from '../styles/index.module.css';
import { Bars } from '../../../components/Icons/Bars';

type ToolNavigationButtonProps = {
	onClick: () => void;
	fill: string;
};

export const ToolNavigationButton: FC<ToolNavigationButtonProps> = ({ onClick, fill }) => {
	return (
		<button
			className={classes.toolNavigation__button}
			type='button'
			onClick={onClick}
			aria-label='toggle tool navigation menu'
			data-testid='tool-navigation-button'
		>
			<Bars fill={fill} />
		</button>
	);
};
